/**
 * 订单号的**展示**口径（`05-ui-design-system.md` §7.8）。
 *
 * 规范原文：**订单号显示：只显示前 8 位，前缀 `订单 `：`订单 C8K3M2XB`**
 * （2026-09-30 统一：原写「后 8 位」与出处栏的 `slice(0, 8)` 及已交付实现矛盾）。
 *
 * ## 这个函数是**全 workspace 唯一**的订单号切片实现
 *
 * Phase 5 Task 22 之前，同一张订单在两端显示成不同字符串（附录 B1k / B1k-bis / B1k-ter 实测）：
 *
 * | 位置 | 旧口径 |
 * |---|---|
 * | `apps/shop` 的 `OrdersPage` / `OrderStatusPage`（三处） | 前 8 位（正确，Phase 4 已交付） |
 * | 收银端 `OrderCard` / `PaymentConfirmModal` / `CashierOrderPage` / `CashierNewOrderPage` | **后 6 位** |
 * | 收银端 `CashierScanPage` | **后 4 位** |
 *
 * 五处现在都调这里；两个应用各自的 spec 断言**同一 orderNo ⇒ 同一字符串**
 * （`apps/tenant/src/cashier/orderNoDisplay.spec.tsx`、`apps/shop/src/lib/orderNoDisplay.spec.ts`），
 * 并静态断言源码里不再出现本地切片（去掉注释后扫 `orderNo` 上的 `slice`）。
 *
 * 前缀 `订单 ` 由调用方写（与 `formatYuan` 只负责 `¥` 之外的分组同一分工）：
 * 五处的句子结构不同（页头、卡片、浮层、弹窗内联），前缀的位置也各不相同。
 */
export function orderNoShort(orderNo: string): string {
  return orderNo.slice(0, 8);
}
